<template>
  <div>
    <el-alert
      title="-14 ve 60 gün aralığındaki kayıtlar"
      type="info"
      center
      :closable="false">
    </el-alert>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      :data="Liste"
      v-if="data"
      row-key="id"
      :height="Height"
      :default-sort="{prop: 'Kalan', order: 'ascending'}"
    >
      <el-table-column
        prop="Unvan"
        label="Unvan">
      </el-table-column>
      <el-table-column
        prop="Kalan"
        label="Kalan Gün"
        width="100">
      </el-table-column>
      <el-table-column
        prop="Sehir"
        label="Sehir"
        width="100">
      </el-table-column>
      <el-table-column
        prop="Telefon"
        label="Telefon"
        width="100">
      </el-table-column>
    </el-table>
  </div>

</template>

<script>
  import Yukleniyor from "../../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: true,
        Liste: null,
        data: null,
        Height: window.innerHeight - 230
      }
    },
    methods: {
      SayfaYukle() {
        this.$store.dispatch("Get", {path: '_a/p/suredolacak'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.lo = false;
              if (this.Liste) this.data = true;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },
    },
    created() {
      this.SayfaYukle();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_a/comp/aiSuresiDolacak.vue